import { render, staticRenderFns } from "./SelectUserAuthority.vue?vue&type=template&id=447650f4&scoped=true&"
import script from "./SelectUserAuthority.vue?vue&type=script&lang=js&"
export * from "./SelectUserAuthority.vue?vue&type=script&lang=js&"
import style0 from "./SelectUserAuthority.vue?vue&type=style&index=0&id=447650f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447650f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
